import { Button,Form, Input,Alert,message } from "antd";
import { connect } from 'react-redux';
import {useState,useEffect,useRef, useCallback } from "react";
import apiCalls from "src/api/apiCalls";
import Loader from "../shared/loader.component";
const { TextArea } = Input;
const ApiEncryption =(props)=>{
    const [publicKey, setPublicKey] = useState('');
    const [errorMessage, setErrorMessage] = useState(null);
    const [loader,setLoader]=useState()
    const [form] = Form.useForm();
    const shouldLog = useRef(true);
    useEffect(() => {
      form.resetFields();setErrorMessage(null)
      if(shouldLog.current){getKey();shouldLog.current = false;}
      }, []);
    const getKey=async()=>{
        try {
            setLoader(true)
          const response = await apiCalls.getDevKey();
          if (response.ok) {
            setPublicKey(response.data?.publicKey);
            form.setFieldsValue({ publicKey: response.data?.publicKey || '' });
            setErrorMessage(null);setLoader(false)
          } else {
            setErrorMessage(apiCalls.isErrorDispaly(response));setLoader(false)
          }
        } catch (error) {
          setErrorMessage(apiCalls.isErrorDispaly(error));setLoader(false)
        }
       }
    const saveKey = useCallback(async(values) => {
         let obj={"publicKey": values.publicKey?.trim(),"createdBy":props.userDetails?.userName}

        setErrorMessage(null);
        let response = await apiCalls.savedevKey(obj);
        if (response.ok) {
          getKey();
            message.destroy();
            message.success({
                content: `Key saved successfully`,
                className: 'custom-msg',
                duration: 4
            });
            setErrorMessage(null);
        } else {
            setErrorMessage(apiCalls.isErrorDispaly(response));
        }
      },[props])

    const closeErrorMsgHandler=useCallback(()=>{
      setErrorMessage(null)
    },[])

    return(
        <div className=''>
        {errorMessage !== null && (
          <Alert
            className='mb-6'
            type="error"
            description={errorMessage}
            onClose={closeErrorMsgHandler}
            showIcon
            closable
          />
        )}
        {loader?<Loader/>:
        <div className="border border-StrokeColor p-4 rounded-5 ">
        <h2 className='text-labelGrey text-base font-medium mb-1'>Set Public Key</h2>
        <div className="w-full text-start">
        <Form className=""
            initialValues={{ publicKey: publicKey }}
                autoComplete="off"
                onFinish={saveKey} form={form}>
                <div className="items-start">
                        <Form.Item name="publicKey"
                        className="mb-0"
                            rules={[
                                {
                                    required: true,
                                    message: 'Is Required',
                                },
                            ]}>
                            <TextArea rows={6} placeholder="Enter public Key" />
                        </Form.Item>
                       
                </div>
                <div className="mt-4">
                    <Button className="primary-btn " htmlType="submit">Save</Button>
                </div>
                </Form>
                </div>
           </div>}
        </div>
    )
}
const connectStateToProps = ({ oidc }) => {
    return {  userDetails: oidc?.user.currentUser}
  }
export default  connect(connectStateToProps)(ApiEncryption);